import React from 'react';

import { InputField } from './';

export const NumberField = props =>
  <InputField min={0} {...props} onChange={props.onChange || props.handleInputChange} type="number" />;
